import { useQuery } from "@tanstack/react-query";
import { Button } from "@rumbledirect/ui";
import { Space } from "antd";
import { Link } from "react-router-dom";
import { fetchUsers } from "@/lib/api/resources/users";
import { EyeOutlined, PlusOutlined } from "@ant-design/icons";
import { useState } from "react";
import { User } from "@rumble-it/common-lib/types/models/User.interface";
import { Table } from "@/components/v2";

export const UsersList = () => {
  const [page, setPage] = useState(1);

  const usersQuery = useQuery({
    queryKey: ["users", page],
    queryFn: () => fetchUsers({ page }),
  });

  const columns = [
    {
      title: "Naam",
      dataIndex: "fullName",
      key: "name",
      render: (text: string, record: User) => (
        <Link to={`/users/${record.id}`}>{text}</Link>
      ),
    },
    { title: "E-mail", dataIndex: "email", key: "email" },
    {
      title: "Rol",
      dataIndex: ["role", "name"],
      key: "role",
    },
    {
      title: "Acties",
      key: "actions",
      render: (_: unknown, record: any) => (
        <Link to={`/users/${record.id}`}>
          <Button icon={<EyeOutlined />} variant="light" />
        </Link>
      ),
    },
  ];

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/users/create">
          <Button icon={<PlusOutlined />}>Nieuwe gebruiker</Button>
        </Link>
      </Space>
      <Table
        rowKey="id"
        dataSource={usersQuery.data?.member}
        columns={columns}
        loading={usersQuery.isLoading}
        pagination={{
          pageSize: 15,
          total: usersQuery.data?.totalItems,
          showSizeChanger: false,
          onChange: (page) => setPage(page),
        }}
      />
    </div>
  );
};
